(function(){
    // scroll animation
    var controller = new ScrollMagic.Controller();
    var mk1 = document.querySelector('#mk1');
    var mouse = true;
    
    if ( !mk1 ) return;
    
    var tl = new TimelineMax();

    tl.from("#mk1-1_l1", 1, {x: "-300%"}, 1.1);
    tl.from("#mk1-1_l2", 1, {x: "-600%"}, 1.6);
    tl.from("#mk1-1_l3", 1, {x: "-1200%"}, 2.2);

    tl.from("#mk1-1_t1", 1, {y: "-80%"}, 1.2);
    tl.from("#mk1-1_t2", 1, {y: "-500%"}, 1.8);
    tl.from("#mk1-1_t3", 1, {y: "-500%"}, 1.8);

    tl.from("#mk1-1_r1", 1, {x: "350%"}, 0.4);
    tl.from("#mk1-1_r2", 1, {x: "700%"}, 2);
    tl.from("#mk1-1_r3", 1, {x: "600%"}, 2.4);
    tl.from("#mk1-1_r4", 1, {x: "130%"}, 3);

    tl.from("#mk1-1_b1", 1, {y: "60%"}, "-=.3");
    tl.from("#mk1-1_b2", 2, {opacity: 0, top: 40});

    var mk1_1_scene = new ScrollMagic.Scene({
      triggerElement: '#mk1-1',
      triggerHook: 'onCenter',
      duration: "70%"
    })
        .setTween(tl)
        .addTo(controller)
        .on('progress', function(e){
            if (mouse && e.progress > 0.1) {
                mouse = true;
                document.querySelector('.mouse-svg').classList.add('off');
            }
        });
  

    // tl2
    var tl2 = new TimelineMax();
    tl2.from("#mk1-4_1", 1, {x: "-250%"}, 1);
    tl2.from("#mk1-4_2", 1, {x: "-250%"}, 1);
    tl2.from("#mk1-4_3", 1, {x: "-70%"}, 1);

    var scene2 = new ScrollMagic.Scene({
      triggerElement: '#mk1-4',
      triggerHook: 'onEnter',
      duration: "70%"
    })

        .setTween(tl2)
        .addTo(controller);

})();